(function(){

function MobHide(container) {
	this.container = container;
	this.moreLink = this.container.find($(".js-more-link"));
	this.items = this.container.find($(".js-item"));
	this.itemLeft = this.container.attr("data-item-left");
	this.init();
}

MobHide.prototype = {
	init: function () {
		this.build();
	},
	count: function(){
		var itemAll = this.container.find($(".js-item")).length;
		return itemAll - this.itemLeft;
	},
	build: function(){	
		if (this.count() > 0){				
			this.mobToggle();	
			this.linkText("show");	
			this.click();
		} else {
			this.moreLink.hide();
		}
	},
	mobToggle: function(){
		var obj = this;
		var state;
		if ($(window).width() < 768) {
				this.hide();
				state = false;
			} else if ($(window).width() >= 768) {	
				this.show();
				state = true;
			}
		$(window).resize(function(){
			if ($(window).width() < 768 && !state) {
				obj.hide();
				obj.linkText("show");
				state = true;
			} else if ($(window).width() >= 768 && state) {
				obj.show();
				obj.linkText("hide");
				state = false;
			}
		});
	},
	hide: function() {
		var obj = this;
		this.items.each(function(index){
			if ((index+1) > obj.itemLeft) {
				$(this).hide();
			}
		});
	},
	show : function() {
		var obj = this;
		this.items.each(function(index){
			$(this).show();
		});
	},
	click: function() {
		var obj = this;
		this.moreLink.on("click", function(e){
			e.preventDefault();
			if (!obj.container.hasClass("is-show")) {
				obj.linkText("hide");
				obj.show();
			} else {
				obj.linkText("show");
				obj.hide();
			}
			obj.container.toggleClass("is-show");
		})
	},
	linkText: function(show){
		if (show == "show" || show == "") {
			this.moreLink.find(".js-link-text").text("Показать всех" + " (" + this.count() + ")");
		} else if (show == "hide") {
			this.moreLink.find(".js-link-text").text("Скрыть" + " (" + this.count() + ")");
		}
	}
};

if($(".team").isset()){
	var team = [];
	$(".js-items-cont").each(function(index){		
		team[index] = new MobHide($($(".js-items-cont")[index]));
	})

}

})()


// WEBPACK FOOTER //
// ./components/js-show-hide.js